import { browseSearchDataModel } from './BrowseSearchDataModel';

const TempDatasourcesHackForFusionDataModels = () => {
  return null;
};

TempDatasourcesHackForFusionDataModels.propTypes = {
};

TempDatasourcesHackForFusionDataModels.displayName = 'TempDatasourcesHackForFusionDataModels';

TempDatasourcesHackForFusionDataModels.dataModel = browseSearchDataModel;

export { TempDatasourcesHackForFusionDataModels };
